import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InterceptorErrorComponent } from './pages/interceptor-error/interceptor-error.component';
import { RecoverPassComponent } from './pages/user_public/recover-pass/recover-pass.component';
import { TestSelectorComponent } from './pages/test-selector/test-selector.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/user_public/user_public.module').then(
        (m) => m.user_publicModule
      ),
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'login/recover-password/:code',
    component: RecoverPassComponent,
    data: {
      title: 'Recuperar clave',
    },
  },
  {
    path: 'error', // Nueva ruta explícita para la página de error
    component: InterceptorErrorComponent,
  },
  {
    path: 'test-selector', // Ruta para probar el selector de idioma
    component: TestSelectorComponent,
  },
  {
    path: '**',
    redirectTo: '/error', // Redirige a la página de error en caso de ruta no encontrada
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
